/**
 * Single-selection option sets for the survey information form.
 *
 * `value` is what gets stored locally, sent to D1 and written to the TXT file.
 * `label` is what the surveyor sees. The Worker validates against the same
 * `value` lists (worker/src/validation/survey.ts) — keep the two in sync.
 */

export interface SelectOption {
  value: string;
  label: string;
}

export const WEATHER_OPTIONS: SelectOption[] = [
  { value: 'clear', label: 'Clear' },
  { value: 'cloud', label: 'Cloud' },
  { value: 'light_rain', label: 'Light Rain' },
  { value: 'heavy_rain', label: 'Heavy Rain' },
];

export const LOCATION_TYPE_OPTIONS: SelectOption[] = [
  { value: 'mid_block', label: 'Mid Block' },
  { value: 'junction', label: 'Junction' },
  { value: 'station_access', label: 'Station Access' },
];

export const ROAD_SURFACE_OPTIONS: SelectOption[] = [
  { value: 'dry', label: 'Dry' },
  { value: 'wet', label: 'Wet' },
  { value: 'affected', label: 'Affected' },
];

export const ROAD_CONFIGURATION_OPTIONS: SelectOption[] = [
  { value: 'two_lane_undivided', label: '2-Lane Undivided' },
  { value: 'divided', label: 'Divided' },
  { value: 'one_way', label: 'One-Way' },
];

/** All 25 Sri Lankan districts, for the manual-override dropdown. */
export const SRI_LANKA_DISTRICTS: string[] = [
  'Ampara',
  'Anuradhapura',
  'Badulla',
  'Batticaloa',
  'Colombo',
  'Galle',
  'Gampaha',
  'Hambantota',
  'Jaffna',
  'Kalutara',
  'Kandy',
  'Kegalle',
  'Kilinochchi',
  'Kurunegala',
  'Mannar',
  'Matale',
  'Matara',
  'Monaragala',
  'Mullaitivu',
  'Nuwara Eliya',
  'Polonnaruwa',
  'Puttalam',
  'Ratnapura',
  'Trincomalee',
  'Vavuniya',
];

export function labelFor(options: SelectOption[], value: string): string {
  return options.find((o) => o.value === value)?.label ?? value ?? '';
}
